import { createRouter, createWebHistory } from 'vue-router'

const NotFound = { template: '<div>Page Not Found 404</div>' }

const routes = [
  {
    path: '/',
    name: 'scanQrCode',
    component: () => import('../views/ScanQrCode.vue')
  },
  {
    path: '/sn/:sn?',
    name: 'productCertify',
    component: () => import(/* webpackChunkName: "about" */ '../views/ProductCertify.vue'),
    props: (route) => {
      // console.log('route:', route)
      return {
        serialNumber: route.params.sn,
        brand: 'weinview'
      }
    }
  },
  {
    path: '/wk/:sn?',
    name: 'weintekProductCertify',
    component: () => import('../views/ProductCertify.vue'),
    props: (route) => ({ serialNumber: route.params.sn, brand: 'weintek' })
  },
  {
    // Manual entry, reached from the scan-the-QR-code page: no QR code means no
    // brand to show, so this one renders unbranded.
    path: '/verify/:sn?',
    name: 'manualCertify',
    component: () => import('../views/ProductCertify.vue'),
    props: (route) => ({ serialNumber: route.params.sn, brand: '' })
  },
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
